import * as React from 'react';
import { ProjectItem, Slider } from './components';
import { useCarouselSettings } from './hooks/useCarouselSettings';
import * as styles from './OtherProjectsCarousel.css';
import { BuilderInfo } from '../components';
import { IOtherProjectsProps } from '../types';

export const OtherProjectsCarousel: React.FC<IOtherProjectsProps> = ({
  items,
  company,
  onBuilderLinkClick,
  onProjectLinkClick,
  onProjectsListChange,
}) => {
  const carouselSettings = useCarouselSettings(items.length);

  return (
    <div className={styles['container']}>
      <div className={styles['inner']}>
        <BuilderInfo {...company} onClick={onBuilderLinkClick} />
        <Slider settings={{ ...carouselSettings, afterChange: onProjectsListChange }}>
          {items.map((projectSnippet, index) => (
            <ProjectItem
              {...projectSnippet}
              key={projectSnippet.id}
              onClick={() => onProjectLinkClick(projectSnippet.id, index)}
            />
          ))}
        </Slider>
      </div>
    </div>
  );
};
